import { ethers } from "ethers";
import { Web3Auth } from "@web3auth/modal";
import { WALLET_ADAPTERS, CHAIN_NAMESPACES } from "@web3auth/base";
import { EthereumPrivateKeyProvider } from "@web3auth/ethereum-provider";
import { MetamaskAdapter } from "@web3auth/metamask-adapter";
import {
  metalordNFTManagerABI,
  metalordNFTManagerAddress,
  metaspaceNFTMarketplaceABI,
  metaspaceNFTMarketplaceAddress,
  nftContractABI,
  lordTokenAddress,
  lordTokenABI,
  nftStakingAddress,
  nftStakingABI,
} from "./data.js";

const clientId = process.env.REACT_APP_CLIENT_ID;
const rpcUrl = "https://polygon-mainnet.infura.io/v3/e6e680025db64b52aaebf6d10558890b"
export const init = async () => {
  try{
    const privateKeyProvider = new EthereumPrivateKeyProvider({
      config:{
        chainConfig:{
          chainNamespace: CHAIN_NAMESPACES.EIP155,
          chainId: "0x89",
          rpcTarget: rpcUrl
        }
      }
    })
    const web3auth = new Web3Auth({
    clientId: clientId,
    web3AuthNetwork: "aqua", // mainnet, aqua, celeste, cyan or testnet
    privateKeyProvider,
    chainConfig: {
      chainNamespace: CHAIN_NAMESPACES.EIP155,
      chainId: "0x89",
      rpcTarget: "https://polygon-mainnet.infura.io/v3/e6e680025db64b52aaebf6d10558890b", // This is the public RPC we have added, please pass on your own endpoint while creating an app
    },
    uiConfig: {
      loginMethodsOrder: ["google", "facebook", "email_passwordless"]
    },
  });

  const metamaskAdapter = new MetamaskAdapter({
    clientId: clientId
  })

  web3auth.configureAdapter(metamaskAdapter)

  await web3auth.initModal({
    modalConfig: {
      [WALLET_ADAPTERS.OPENLOGIN]: {
        label: "openlogin",
        loginMethods: {
          google: {
            name: "google login",
            logoDark: "url to your custom logo which will shown in dark mode",
          },
          facebook: {
            // it will hide the facebook option from the Web3Auth modal.
            showOnModal: false,
          }
        },
        // setting it to false will hide all social login methods from modal.
        showOnModal: true,
      },
      [WALLET_ADAPTERS.METAMASK]: {
      label: "metamask",
      showOnModal: true,
      },
    },
  });

  const web3authProvider = await web3auth.connect();

  const provider = new ethers.providers.Web3Provider(web3authProvider);
  console.log(provider, "---------provider---------------");
  const signer = provider.getSigner();
  console.log(signer, "----------signer-------------");
  const address = await signer.getAddress();
  console.log(address, "-----------address---------------");
  const idToken=await web3auth.authenticateUser();
  console.log(idToken?.idToken,';;;;;;;;;;;;;;;;;;;;')
  localStorage.setItem("userinfo",idToken?.idToken)
  
  const userInfo=await web3auth.getUserInfo();
  let loginType='provider';
  if(userInfo?.typeOfLogin){
    loginType='provider'
  }else{
    loginType='email'
  }
  localStorage.setItem("provider",loginType)


  const metalordNFTManagerContract = new ethers.Contract(
    metalordNFTManagerAddress,
    metalordNFTManagerABI,
    signer
  );
  const metaspaceNFTMarketplaceContract = new ethers.Contract(
    metaspaceNFTMarketplaceAddress,
    metaspaceNFTMarketplaceABI,
    signer
  );
  const nftStakingContract = new ethers.Contract(
    nftStakingAddress,
    nftStakingABI,
    signer
  );
  const logout = async () => {
    return await web3auth.logout();
  };

  return {
    provider,
    signer,
    address,
    metalordNFTManagerContract,
    metaspaceNFTMarketplaceContract,
    nftStakingContract,
    idToken,
    loginType,
    logout,
  };
  }catch(err){
    console.log("error in web3auth connection",err)
  }
};

export const balanceOf = async (lordTokenContract, userAddress) => {
  return await lordTokenContract.balanceOf(userAddress);
};

export const getBalance = async (provider, userAddress) => {
  return await provider.getBalance(userAddress);
};

export const sendToken = async (lordTokenContract, userAddress, amount) => {
  const tx = await lordTokenContract.transfer(userAddress, amount);
  const rec = await tx.wait();
  return rec;
};

export const checkAllowance = async (
  lordTokenContract,
  userAddress,
  spender
) => {
  return await lordTokenContract.allowance(userAddress, spender);
};

export const approve = async (lordTokenContract, spender) => {
  const tx = await lordTokenContract.approve(
    spender,
    "115792089237316195423570985008687907853269984665640564039457n"
  );
  const rec = await tx.wait();
  return rec;
};
